import Header from '@/components/layout/header'
import MobileBottomBar from '@/components/layout/mobile-bottom-bar'
import BookingEngine from '@/components/sections/booking-engine'
import Hero from '@/components/sections/hero'
import ImageText from '@/components/sections/image-text'
import ProductGrid from '@/components/sections/product-grid'
import SingleParagraph from '@/components/sections/single-paragraph'
import Spacer from '@/components/sections/spacer'

export const sectionsMap: any = {
  hero: Hero,
  product_grid: ProductGrid,
  booking_engine: BookingEngine,
  image_text: ImageText,
  simple_paragraph: SingleParagraph,
  mobile_bottom_bar: MobileBottomBar,
  header: Header,
  spacer: Spacer
}
